<template>
    <Dialog v-model:open="open">
        <DialogTrigger as-child>
            <slot />
        </DialogTrigger>
        <DialogContent class="sm:max-w-[425px]">
            <DialogHeader>
                <DialogTitle> {{ $t("teams.update_role") }}</DialogTitle>
            </DialogHeader>
            <form @submit.prevent="updateRole">
                <div class="gap-4 py-4 grid">
                    <RoleSelect v-model="role" />
                </div>
                <DialogFooter>
                    <ZButton class="ml-4" type="submit">
                        {{ $t("teams.update_role") }}
                    </ZButton>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import ZButton from "../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";

import RoleSelect from "./RoleSelect.vue";
import type { Team, User } from "../types/Team";

interface Props {
    team: Team;
    teamUser: User;
}

const props = defineProps<Props>();

const open = ref(false);
const role = ref(props.teamUser.membership.role);

console.log(role.value);

async function updateRole() {
    if (role.value === "owner") {
        router.post(
            route("app.teams.change-owner", { team: props.team.id }),
            {
                newOwnerId: props.teamUser.id,
            },
            {
                onFinish: () => {
                    open.value = false;
                },
            },
        );

        return;
    }

    router.put(
        route("team-members.update", {
            team: props.team.id,
            user: props.teamUser.id,
        }),
        {
            role: role.value,
        },
        {
            onFinish: () => {
                open.value = false;
            },
        },
    );
}
</script>
